export default {
  methods: {
    sendMetricks () {
      _txq.push(['track', 'social'])
      this.$dspCounter('send')
    }
  }
}
